<script setup lang="ts">
type Item = {
  title: string
  content: string
}

type Props = {
  itemAllSpecies: Item
  itemRedlistedSpecies: Item
  callToAction?: unknown
  ctaLabel?: string
}

const _props = defineProps<{ data: Props; theme: string | null }>()

const { data: speciesData } = await useSpeciesData(_props.data.polygon)
</script>

<template>
  <div class="px-bleed relative w-full overflow-clip">
    <div class="grid gap-15 lg:grid-cols-2 lg:gap-5">
      <div>
        <h3 class="font-display mb-10 text-xl lg:mb-18">
          <span class="mr-5 text-2xl lg:text-5xl">
            {{
              (speciesData?.allSpecies.hydratedFacets.taxonId.totalCount || 0).toLocaleString(
                'da-DK',
              )
            }}</span
          >{{ data.itemAllSpecies.title }}
        </h3>
        <ElementsPortableTextWrapper :content="data.itemAllSpecies.content" />
      </div>
      <div>
        <h3 class="font-display mb-10 text-xl lg:mb-18">
          <span class="mr-5 text-2xl lg:text-5xl">{{
            (speciesData?.redlistedSpecies.hydratedFacets.taxonId.totalCount || 0).toLocaleString(
              'da-DK',
            )
          }}</span
          >{{ data.itemRedlistedSpecies.title }}
        </h3>
        <ElementsPortableTextWrapper :content="data.itemRedlistedSpecies.content" />
      </div>
    </div>

    <div v-if="data?.callToAction?.length > 0" class="ctas my-20 flex w-full flex-col gap-2.5">
      <CommonBasicLink
        v-for="(cta, index) in data?.callToAction"
        :link="cta"
        :key="index"
        class="font-display flex w-full items-center justify-between rounded-sm border bg-(--theme-fg) px-5 py-3 text-lg text-(--theme-bg) transition-colors duration-200 hover:border hover:border-(--theme-fg) hover:bg-(--theme-bg) hover:text-(--theme-fg)"
      >
        <span class="hidden lg:flex">{{ data.ctaLabel }}</span>
        <span class="flex shrink-0 items-center gap-4"
          >{{ cta.label }}
          <IconsArrowUpRight class="size-4" />
        </span>
      </CommonBasicLink>
    </div>
  </div>
</template>
